export default __webpack_public_path__ + "312e3f7152b689603e158272b4ff3fb8.png";